











































import { Component } from "vue-property-decorator";
import DataCard from "../utility/DataCard.vue";
import Debug from "../utility/Debug.vue";
import { mixins } from "vue-class-component";
import ThgBillingSelectionItemPartnerDataMixin from "@/mixins/ThgBillingSelectionItemPartnerDataMixin.vue";

@Component({ components: { Debug, DataCard } })
export default class ThgBillingSelectionItemPartnerIdentityData extends mixins(
  ThgBillingSelectionItemPartnerDataMixin
) {}
